import { FC, SVGAttributes } from 'react';

const StateErrorLine: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" {...props}>
      <path
        d="M10.7306 8.15043C10.6552 7.39697 11.2469 6.74316 12.0041 6.74316C12.7614 6.74316 13.353 7.39697 13.2777 8.15043L12.7816 12.7964C12.7417 13.1958 12.4056 13.5 12.0041 13.5C11.6027 13.5 11.2666 13.1958 11.2266 12.7964L10.7306 8.15043Z"
        fill="currentColor"
      />
      <path
        d="M10.5898 16.6432C10.5898 15.8621 11.223 15.2289 12.0041 15.2289C12.7852 15.2289 13.4184 15.8621 13.4184 16.6432C13.4184 17.4243 12.7852 18.0574 12.0041 18.0574C11.223 18.0574 10.5898 17.4243 10.5898 16.6432Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12.5C22 18.0228 17.5228 22.5 12 22.5C6.47715 22.5 2 18.0228 2 12.5C2 6.97715 6.47715 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5ZM20.5 12.5C20.5 17.1944 16.6944 21 12 21C7.30558 21 3.5 17.1944 3.5 12.5C3.5 7.80558 7.30558 4 12 4C16.6944 4 20.5 7.80558 20.5 12.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default StateErrorLine;
